module.exports = "<div psa-mini-policy-change vehicle=\"vehicle\" on-proceed=\"onProceed\"></div>"